import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const leadAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<Lead>>('/api/info/leads', { params }).then(({ data }) => data),
  update: (id: number | string, data: LeadFormPayload) => http.put<unknown>(`/api/edit/leads/${id}`, { data }),
  create: (data: LeadFormPayload) => http.post<unknown>(`/api/add/leads`, { data }),
  delete: (id: number | string) => http.delete<unknown>(`/api/delete/leads/${id}`),
  detail: (id: number | string) => http.get<DataResponse<Lead>>(`/api/info/leads/${id}`).then(({ data }) => data),
  history: (id: number | string) =>
    http.get<SaleHistory<Lead>[]>(`/api/info/history_leads/${id}`).then(({ data }) => data),
};

export const leadQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetLeads', params] as const,
      queryFn: () => leadAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  detail: (id: number | string) =>
    ({
      queryKey: ['GetDetailLead', id] as const,
      queryFn: () => leadAPI.detail(id),
    }) as const satisfies QueryOptions,
  list_by_phone: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetLeadsByPhone', params] as const,
      queryFn: () => leadAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  history: (id: number | string) =>
    ({
      queryKey: ['GetLeadHistory', id] as const,
      queryFn: () => leadAPI.history(id),
    }) as const satisfies QueryOptions,
};
